<!--
// app/components/pages/region-matches/HeaderTableMatches.vue
-->
<script setup lang="ts">
type Props = {
  showGroup: boolean;
  showTickets: boolean;
};

defineProps<Props>();
</script>

<template>
  <div
    class="uppercase px-4 mb-2.5 hidden text-gray-400 text-xs lg:grid lg:grid-cols-[6rem_5rem_1fr_10rem] lg:gap-4"
  >
    <div>{{ $t("matches.turn.date") }}</div>
    <div>{{ $t("matches.turn.schedule") }}</div>
    <div class="text-center">
      {{ $t("matches.turn.match") }}
    </div>
    <div class="flex items-center justify-end gap-8">
      <div class="text-right rtl:text-left min-w-14">
        {{ $t("matches.turn.status") }}
      </div>
      <div v-if="showGroup" class="text-right rtl:text-left min-w-14">
        {{ $t("matches.turn.group") }}
      </div>
      <div v-if="showTickets" class="text-right rtl:text-left min-w-14">
        {{ $t("header.tickets") }}
      </div>
    </div>
  </div>
</template>

<style scoped></style>
